export default {
  apiBaseUrl: 'https://staging-chloe-api.peoplescience.health/api/',
  socketUrl: 'https://staging-chloe-api.peoplescience.health/',
  webUrl: 'https://staging-chloe.peoplescience.health',
  appWebUrl: 'https://staging-chloe-app.peoplescience.health',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  referralUrl: 'https://staging-chloe.peoplescience.health/referrals/',
  fitbitWebClientId: '238QN8',
  fitbitAppClientId: '23RDMR',
  fitbitRedirectWebUri: 'https://staging-chloe-app.peoplescience.health/*',
  oAuthRedirectWebUri: 'https://staging-chloe-app.peoplescience.health/*',
  oAuthRedirectAppUri: 'health.peoplescience.chloe3.staging://MyStudiesScreen',
  ouraAppClientId: '2K6J2XL6MHCZJQWB',
  appcuesAppId: 'e5da3361-134f-4b8d-8d87-f1733c55ded4',
  appcuesAccountId: '209423',
  googleFitScopes: [
    'https://www.googleapis.com/auth/fitness.sleep.read',
    'https://www.googleapis.com/auth/fitness.activity.read',
    'https://www.googleapis.com/auth/fitness.body.read',
    'https://www.googleapis.com/auth/fitness.nutrition.read',
    'https://www.googleapis.com/auth/fitness.blood_pressure.read',
    'https://www.googleapis.com/auth/fitness.blood_glucose.read',
    'https://www.googleapis.com/auth/fitness.oxygen_saturation.read',
    'https://www.googleapis.com/auth/fitness.body_temperature.read',
    'https://www.googleapis.com/auth/fitness.heart_rate.read'
  ],
  recaptchaSiteKey: '6Le-tX8oAAAAAO5qcnzxj1TLPx5E0oaoZYe5P70s',
  googleTagManagerId: 'GTM-TP4P4FQ'
};
